export default {
  // apps quickmenu
  apps: [{
    icon: 'mdi-email-outline',
    text: 'RFQ',
    key: 'RFQ',
    
    link: '/apps/email/inbox'
  },  {
    icon: 'mdi-message-outline',
    title: 'Chat',
    key: 'menu.chat',
    link: '/apps/chat/channel/general'
  }, {
    icon: 'mdi-view-column-outline',
    title: 'Quote Pipeline',
    key: 'Quote Pipeline',
    link: '/apps/board'
  }],

  // user dropdown menu
  user: [
    { icon: 'mdi-account-box-outline', key: 'menu.profile', text: 'Profile', link: '/users/edit' },
    { icon: 'mdi-email-outline', key: 'menu.email', text: 'Email', link: '/apps/email' },
    { icon: 'mdi-format-list-checkbox', key: 'menu.todo', text: 'Todo', link: '/apps/todo' },
    { icon: 'mdi-email-outline', key: 'menu.chat', text: 'Chat', link: '/apps/chat' },
    { icon: 'mdi-email-outline', key: 'menu.board', text: 'Board', link: '/apps/board' }
  ]
}
